import { z } from "zod";
import { AccrualExtractionLineItemSchema } from "@common/dto/financialDocument/accrual-document-extraction.schema";

export const InvoiceExtractionLineItemSchema =
    AccrualExtractionLineItemSchema.extend({
        lineId: z.string().uuid(),
        catalogItemId: z.string().uuid().nullable().optional(),
        catalogItemPriceId: z.string().uuid().nullable().optional(),
    });

export type InvoiceExtractionLineItem = z.infer<
    typeof InvoiceExtractionLineItemSchema
>;

const AccrualExtractionLineItemRowBaseSchema =
    AccrualExtractionLineItemSchema.extend({
        id: z.string().uuid(),
        rowIndex: z.number().int().min(0).max(499),
    });

export const InvoiceExtractionLineItemRowSchema =
    AccrualExtractionLineItemRowBaseSchema.extend({
        catalogItemId: z.string().uuid().nullable().optional(),
        catalogItemPriceId: z.string().uuid().nullable().optional(),
    });

export type InvoiceExtractionLineItemRow = z.infer<
    typeof InvoiceExtractionLineItemRowSchema
>;

export const BillExtractionLineItemRowSchema =
    AccrualExtractionLineItemRowBaseSchema;

export type BillExtractionLineItemRow = z.infer<
    typeof BillExtractionLineItemRowSchema
>;
